import { Link } from "react-router-dom";
import { Edit3, Layers, Upload, Settings, ArrowLeft } from "lucide-react";

export default function BuildExams() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                {/* Banner */}
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Build Exams</h1>
                </div>

                <p className="text-gray-600 mb-8">
                    Create professional, secure exams in minutes. Manage question banks, versions,
                    and assignments with granular control.
                </p>

                {/* Feature grid */}
                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Edit3 className="w-5 h-5" />
                            <h3 className="font-semibold">Rich Authoring</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Multiple question types (MCQ, essay, code, file upload)</li>
                            <li>� Images, math (LaTeX), and media</li>
                            <li>� Time limits, randomization, section rules</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Layers className="w-5 h-5" />
                            <h3 className="font-semibold">Question Banks</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Centralized reusable items & tagging</li>
                            <li>� Difficulty levels & blueprinting</li>
                            <li>� Item statistics & version history</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Upload className="w-5 h-5" />
                            <h3 className="font-semibold">Bulk Import</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� CSV/JSON import & validation</li>
                            <li>� Batch tagging / ownership</li>
                            <li>� Error reporting & rollback</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Settings className="w-5 h-5" />
                            <h3 className="font-semibold">Assignments & Policies</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Cohorts, windows, attempts, retakes</li>
                            <li>� Accommodations & test forms</li>
                            <li>� Secure delivery profile presets</li>
                        </ul>
                    </div>
                </section>

                <div className="mt-8 flex flex-wrap gap-3">
                    <Link to="/support/contact" className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">Talk to Sales</Link>
                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 hover:text-indigo-800 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
